import React, { useEffect, useState } from "react";
import fundIcon from "../assets/images/fund.svg";
import pensionfundsIcon from "../assets/images/pension-funds.svg";
import providentfundsIcon from "../assets/images/provident-funds.svg";
import insurancefundsIcon from "../assets/images/insurance-funds.svg";
import educationfundsIcon from "../assets/images/education-funds.svg";
import lifeinsuranceIcon from "../assets/images/life-insurance.svg";
import mortgageinsuranceIcon from "../assets/images/mortgage-insurance.svg";
import widowspensionIcon from "../assets/images/widows-pension.svg";
import orphansallowanceIcon from "../assets/images/orphans-allowance.svg";
import disabilityallowanceIcon from "../assets/images/disability-allowance.svg";
import Skeleton from "@mui/material/Skeleton";

const FundsCard = ({ pensionData, count, from, onboardingStep, balances }) => {
  const [balanceData, setBalanceData] = useState([]);
  const [balanceDataFields, setBalanceDataFields] = useState([
    { field: "not_approved" },
    { field: "not_approved" },
    { field: "not_approved" },
    { field: "not_approved" },
    { field: "not_approved" },
    { field: "not_approved" },
    { field: "not_approved" },
    { field: "not_approved" },
    { field: "not_approved" },
    { field: "not_approved" },
  ]);
  const [loading, setLoading] = useState(true);
  const [fundsData, setFundsData] = useState(
    from === "finance"
      ? [
          {
            icon: fundIcon,
            text: "סה”כ הכספים שנצברו עד היום",
            key: "field_1",
          },
          { icon: providentfundsIcon, text: "קופות גמל", key: "field_3" },
          { icon: insurancefundsIcon, text: "מנהלים", key: "field_4" },
          { icon: educationfundsIcon, text: "קרנות השתלמות", key: "field_5" },
          { icon: lifeinsuranceIcon, text: "שיעור דמי ניהול", key: "field_6" },
          { icon: mortgageinsuranceIcon, text: "סך דמי ניהול", key: "field_7" },
          {
            icon: widowspensionIcon,
            text: "ממוצע תשואות השנה",
            key: "field_8",
          },
          {
            icon: orphansallowanceIcon,
            text: "ממוצע הפקדות חוסך",
            key: "field_9",
          },
          {
            icon: disabilityallowanceIcon,
            text: "ממוצע הפקדות מעסיק",
            key: "field_10",
          },
        ]
      : from === "pension"
      ? [
          {
            icon: fundIcon,
            text: "סה”כ הכספים שנצברו עד היום",
            key: "field_1",
          },
          { icon: pensionfundsIcon, text: "קרנות פנסיה", key: "field_2" },
          { icon: insurancefundsIcon, text: "מנהלים", key: "field_4" },
          { icon: widowspensionIcon, text: "קצבת אלמן", key: "field_8" },
          { icon: orphansallowanceIcon, text: "קצבת יתום", key: "field_9" },
          {
            icon: disabilityallowanceIcon,
            text: "קצבת אי כושר עבודה",
            key: "field_10",
          },
        ]
      : [
          {
            icon: fundIcon,
            text: "סה”כ הכספים שנצברו עד היום",
            key: "field_1",
          },
          { icon: pensionfundsIcon, text: "קרנות פנסיה", key: "field_2" },
          { icon: providentfundsIcon, text: "קופות גמל", key: "field_3" },
          { icon: insurancefundsIcon, text: "מנהלים", key: "field_4" },
          { icon: educationfundsIcon, text: "קרנות השתלמות", key: "field_5" },
          { icon: lifeinsuranceIcon, text: "כיסוי ביטוח חיים", key: "field_6" },
          {
            icon: mortgageinsuranceIcon,
            text: "כיסוי ביטוח משכנתא",
            key: "field_7",
          },
          { icon: widowspensionIcon, text: "קצבת אלמן", key: "field_8" },
          { icon: orphansallowanceIcon, text: "קצבת יתום", key: "field_9" },
          {
            icon: disabilityallowanceIcon,
            text: "קצבת אי כושר עבודה",
            key: "field_10",
          },
        ]
  );

  useEffect(() => {
    const fetchData = async () => {
      if (!pensionData) return;
      try {
        setBalanceData(balances);
        const processedDataSummary = [
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.Yetrot?.reduce(
                    (sum, item) =>
                      sum +
                      (parseFloat(item.Pensya || 0) || 0) +
                      (parseFloat(item.Gemel || 0) || 0) +
                      (parseFloat(item.Manager || 0) || 0) +
                      (parseFloat(item.Hishtalmut || 0) || 0),
                    0
                  ) || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.Yetrot?.reduce(
                    (sum, item) => sum + parseFloat(item.Pensya),
                    0
                  ) || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.Yetrot?.reduce(
                    (sum, item) => sum + parseFloat(item.Gemel),
                    0
                  ) || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.Yetrot?.reduce(
                    (sum, item) => sum + parseFloat(item.Manager),
                    0
                  ) || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.Yetrot?.reduce(
                    (sum, item) => sum + parseFloat(item.Hishtalmut),
                    0
                  ) || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0].Haim || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0].Mashkanta || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0].Alman || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0].Yeled || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0].Kosher || "0"
                : "not_approved",
          },
        ];
        const processedDataFinance = [
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.Yetrot?.reduce(
                    (sum, item) =>
                      sum +
                      (parseFloat(item.Gemel || 0) || 0) +
                      (parseFloat(item.Manager || 0) || 0) +
                      (parseFloat(item.Hishtalmut || 0) || 0),
                    0
                  ) || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.Yetrot?.reduce(
                    (sum, item) => sum + (parseFloat(item.Gemel || 0) || 0),
                    0
                  ) || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.Yetrot?.reduce(
                    (sum, item) => sum + (parseFloat(item.Manager || 0) || 0),
                    0
                  ) || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.Yetrot?.reduce(
                    (sum, item) =>
                      sum + (parseFloat(item.Hishtalmut || 0) || 0),
                    0
                  ) || "0"
                : "not_approved",
          },

          {
            field:
              onboardingStep >= 4 || (pensionData && pensionData.length)
                ? (() => {
                    const items = pensionData;

                    let total = 0;
                    let count = 0;

                    items.forEach((item) => {
                      // if (item?.duplicate === true) return;
                      item.PirteiTaktziv.forEach((pt) => {
                        const value = parseFloat(
                          pt.HotzaotBafoalLehodeshDivoach
                            ?.SHEUR_DMEI_NIHUL_TZVIRA || "0"
                        );
                        if (
                          item.STATUS_POLISA_O_CHESHBON == "1" ||
                          item.STATUS_POLISA_O_CHESHBON == 1
                        ) {
                          total += value;
                          count += 1;
                        }
                      });
                    });

                    const avg = count > 0 ? total / count : 0;
                    return total;
                  })()
                : "not_approved",
          },
          {
            field:
              onboardingStep >= 4 || (pensionData && pensionData.length)
                ? (() => {
                    const items = pensionData;

                    let total = 0;
                    let count = 0;

                    items.forEach((item) => {
                      // if (item?.duplicate === true) return;
                      item.PirteiTaktziv.forEach((pt) => {
                        const value = parseFloat(
                          pt.HotzaotBafoalLehodeshDivoach
                            ?.TOTAL_DMEI_NIHUL_POLISA_O_HESHBON || "0"
                        );
                        if (
                          item.STATUS_POLISA_O_CHESHBON == "1" ||
                          item.STATUS_POLISA_O_CHESHBON == 1
                        ) {
                          total += value;
                          count += 1;
                        }
                      });
                    });

                    const avg = count > 0 ? total / count : 0;
                    return total;
                  })()
                : "not_approved",
          },


          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.Tsua || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.HafkadaHosech || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.HafkadaMaasik || "0"
                : "not_approved",
          },
        ];
        const processedDataPension = [
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.Yetrot?.reduce(
                    (sum, item) =>
                      sum +
                      (parseFloat(item.Pensya || 0) || 0) +
                      (parseFloat(item.Manager || 0) || 0),
                    0
                  ) || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.Yetrot?.reduce(
                    (sum, item) => sum + parseFloat(item.Pensya),
                    0
                  ) || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.Yetrot?.reduce(
                    (sum, item) => sum + parseFloat(item.Manager),
                    0
                  ) || "0"
                : "not_approved",
          },


          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0].Alman || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0].Yeled || "0"
                : "not_approved",
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0].Kosher || "0"
                : "not_approved",
          },
        ];
        setBalanceDataFields(
          from === "finance" ? processedDataFinance : from === "pension" ? processedDataPension : processedDataSummary
        );
      } catch (error) {
        console.error("Error fetching balance data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [pensionData]);

  return (
    <>
      {from === "finance" ? (
        <div className="funds-cards cards-nine d-flex flex-wrap gap-16">
          {fundsData.slice(0, count).map((fund, index) => (
            <div key={index} className="cards-box white-bg radius-16">
              <div className="icon d-flex align-items-center justify-content-center white-bg radius-100">
                <img src={fund.icon} alt="Icon" />
              </div>
              <div className="content">
                <p>{fund.text}</p>
                <h3
                  style={
                    index == 6
                      ? { direction: "ltr", float: "inline-start" }
                      : undefined
                  }
                >
                  {console.log(
                    "balanceDataFields.length",
                    balanceDataFields.length
                  )}
                  {balanceDataFields.length > 0 && !loading ? (
                    balanceDataFields[index]?.field &&
                    balanceDataFields[index]?.field !== "0" &&
                    !isNaN(parseFloat(balanceDataFields[index]?.field)) ? (
                      `${index === 6 || index === 4 ? "" : "₪"}${parseFloat(
                        balanceDataFields[index].field
                      ).toLocaleString("he-IL", {
                        minimumFractionDigits: String(
                          balanceDataFields[index].field
                        ).includes(".")
                          ? 2
                          : 0,
                        maximumFractionDigits: String(
                          balanceDataFields[index].field
                        ).includes(".")
                          ? 2
                          : 0,
                      })}${index === 6 || index === 4 ? "%" : ""}`
                    ) : (
                      0
                    )
                  ) : (
                    <Skeleton
                      variant="rectangular"
                      width="118px"
                      height="24px"
                      animation="wave"
                      sx={{ backgroundColor: "#F3F3F4", borderRadius: 1 }}
                    />
                  )}
                </h3>
              </div>
            </div>
          ))}
        </div>
      ) : from === "pension" ? (
        <div className="funds-cards funds-cards-3 d-flex flex-wrap gap-16">
          {fundsData.slice(0, count).map((fund, index) => (
            <div key={index} className="cards-box white-bg radius-16">
              <div className="icon d-flex align-items-center justify-content-center white-bg radius-100">
                <img src={fund.icon} alt="Icon" />
              </div>
              <div className="content">
                <p>{fund.text}</p>
                <h3
                  style={
                    index == 6
                      ? { direction: "ltr", float: "inline-start" }
                      : undefined
                  }
                >
                  {console.log(
                    "balanceDataFields.length",
                    balanceDataFields.length
                  )}
                  {balanceDataFields.length > 0 && !loading ? (
                    balanceDataFields[index]?.field &&
                    balanceDataFields[index]?.field !== "0" &&
                    !isNaN(parseFloat(balanceDataFields[index]?.field)) ? (
                      `${index === 6  ? "" : "₪"}${parseFloat(
                        balanceDataFields[index].field
                      ).toLocaleString("he-IL", {
                        minimumFractionDigits: String(
                          balanceDataFields[index].field
                        ).includes(".")
                          ? 2
                          : 0,
                        maximumFractionDigits: String(
                          balanceDataFields[index].field
                        ).includes(".")
                          ? 2
                          : 0,
                      })}${index === 6  ? "%" : ""}`
                    ) : (
                      0
                    )
                  ) : (
                    <Skeleton
                      variant="rectangular"
                      width="118px"
                      height="24px"
                      animation="wave"
                      sx={{ backgroundColor: "#F3F3F4", borderRadius: 1 }}
                    />
                  )}
                </h3>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="funds-cards d-flex flex-wrap gap-16">
          {fundsData.slice(0, count).map((fund, index) => (
            <div key={index} className="cards-box white-bg radius-16">
              <div className="icon d-flex align-items-center justify-content-center white-bg radius-100">
                <img src={fund.icon} alt="Icon" />
              </div>
              <div className="content">
                <p>{fund.text}</p>
                <h3>
                  {balanceDataFields.length === 0 ||
                  loading ||
                  pensionData === null ? (
                    <Skeleton
                      variant="rectangular"
                      width="118px"
                      height="24px"
                      animation="wave"
                      sx={{ backgroundColor: "#F3F3F4", borderRadius: 1 }}
                    />
                  ) : balanceDataFields[index]?.field &&
                    balanceDataFields[index]?.field !== "0" &&
                    !isNaN(parseFloat(balanceDataFields[index]?.field)) ? (
                    `₪${parseFloat(
                      balanceDataFields[index].field
                    ).toLocaleString()}`
                  ) : (
                    0
                  )}
                </h3>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default FundsCard;
